import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { type ILogObj, Logger } from 'tslog';
import { type ViewportChange } from '@bizzdesign/modeler/models';
import { GraphActionsToolbarService } from './graph-actions-toolbar.service';

export const defaultDisabledBtnMap: [string, boolean][] = [
  ['undo', true],
  ['redo', true],
  ['publishToRepository', true],
];

const initialViewport: ViewportChange = { x: 0, y: 0, zoom: 1 };

@Injectable()
export class ModelerCommunicationService {
  readonly #graphActionsToolbarService = inject(GraphActionsToolbarService);

  logger: Logger<ILogObj> = new Logger({
    overwrite: {
      transportFormatted: (
        logMetaMarkup: string,
        logArgs: unknown[],
        logErrors: string[],
      ): void => {
        console.log(...logArgs);
      },
    },
  });
  disabledButtons$ = new BehaviorSubject<Map<string, boolean>>(
    new Map<string, boolean>(defaultDisabledBtnMap),
  );
  disabledBtns$ = this.disabledButtons$.pipe(
    map((btns) => (btns ? Object.fromEntries(btns) : {})),
  );

  readonly #viewportChanged$ = new BehaviorSubject<ViewportChange>(
    initialViewport,
  );
  viewportChanged$ = this.#viewportChanged$.asObservable();

  viewportChanged(viewport: ViewportChange) {
    this.#viewportChanged$.next(viewport);
  }

  onNewActionTriggered() {
    this.#graphActionsToolbarService._actionTrigger$.next({
      key: 'cancelAction',
      isBlocking: false,
    });
  }

  updateDisabledMap(key: string, value: boolean) {
    const buttonsMap = this.disabledButtons$.value;
    if (buttonsMap === null) return;
    const updatedButtonsMap = new Map(buttonsMap);
    updatedButtonsMap.set(key, value);
    this.disabledButtons$.next(updatedButtonsMap);
  }
}
